import { z } from 'zod/v3';

export const ControlPresentationSchema = z.object({
  title: z.string().min(1),
  requirement: z.string().min(1),
  implementation: z.string().min(1),
  whyItMatters: z.string().min(1).optional(),
  typicalEvidence: z.string().min(1).optional(),
  /** Workspace edits retained when company-specific copy is republished. */
  overrides: z.object({
    title: z.string().trim().min(1).max(200).optional(),
    requirement: z.string().trim().min(1).max(5000).optional(),
  }).optional(),
});
export type ControlPresentationDTO = z.infer<typeof ControlPresentationSchema>;

export const ControlMatrixPublicationSchema = z.object({
  inputHash: z.string(),
  templateVersion: z.number().int(),
  publishedAt: z.string().datetime(),
  publishedBy: z.string().nullable(),
});
export type ControlMatrixPublicationDTO = z.infer<typeof ControlMatrixPublicationSchema>;

export interface ControlMatrixPublicationStatusDTO {
  publishedAt: string | null;
  pending: boolean;
  controlCount: number;
}
